import { render, staticRenderFns } from "./recordedStyle.vue?vue&type=template&id=495aaf39&scoped=true"
import script from "./recordedStyle.vue?vue&type=script&lang=js"
export * from "./recordedStyle.vue?vue&type=script&lang=js"
import style0 from "./recordedStyle.vue?vue&type=style&index=0&id=495aaf39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495aaf39",
  null
  
)

export default component.exports